export default {
	computed: {
		historyGraphdata: function() {
			return Array(28)
				.fill()
				.map((e, index) => {
					const date = this.$dayjs(this.$store.state.rundate).subtract(
						index,
						'd'
					);
					const forecast = this.area.forecasthistory.find(forecastItem => {
						return date.isSame(forecastItem.rundate, 'd');
					});
					return {
						value: forecast ? forecast.snowTotal : 0,
						barLabel: forecast ? forecast.snowTotal + 'cm' : '',
						label: this.$dayjs(date).format('D MMM')
					};
				})
				.reverse();
			// return this.forecasthistory.map(e => {
			//   return {
			//     value: e.snowTotal,
			//     barLabel: e.snowTotal + 'cm',
			//     label: this.$dayjs(e.rundate).format('D MMM')
			//   };
			// });
		}
	}
};
